module.exports = __webpack_public_path__ + "img/popup-hd2.fca2b91d.png";